export default __webpack_public_path__ + "static/media/master_b3_3_epb.9148ba1b.jpg";